export default __webpack_public_path__ + "static/media/area.bb374475.jpg";